import { useCallInsightController } from '@frontend/call-insight-panel';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useCallIntelNotification = () => {
  const { create, remove } = useNotification<'unhappy-call'>();
  const { open: openCallInsightPanel } = useCallInsightController({
    source: 'unhappyCallNotification',
  });
  useCommonActionSubscriptions('unhappy-call');

  useNotificationActionSubscription(
    'unhappy-call',
    'view',
    ({ notification }) => {
      const { callId, locationId } = notification.payload;
      if (callId && locationId) {
        openCallInsightPanel({
          channelId: callId,
          locationId: locationId,
          includeCallIntelligence: true,
        });
      }
      remove(notification.id);
    },
    []
  );

  return {
    create,
    remove,
  };
};
